import React from 'react';
import { IconProps } from '../IconProps';
const SvgCrowd = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <g clipPath="url(#Crowd_svg__clip0_1472_4380)" fill="#200C05">
      <path d="M4.25 13.75a4.276 4.276 0 00-4.074 3.036.75.75 0 00.719.964h6.71a.75.75 0 00.719-.964A4.275 4.275 0 004.25 13.75zM13.75 13.75a4.276 4.276 0 00-4.074 3.036.75.75 0 00.719.964h6.71a.75.75 0 00.719-.964 4.275 4.275 0 00-4.074-3.036zM4.25 12.5a2 2 0 100-4 2 2 0 000 4zM13.75 12.5a2 2 0 100-4 2 2 0 000 4zM9 4.5a2 2 0 100-4 2 2 0 000 4zM7.67 9.752h2.66a3.507 3.507 0 011.961-2.434 4.276 4.276 0 00-3.29-1.566 4.276 4.276 0 00-3.292 1.566 3.507 3.507 0 011.96 2.434z" />
    </g>
    <defs>
      <clipPath id="Crowd_svg__clip0_1472_4380">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrowd;
